<script lang="ts">
  export let size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'md'
  export let centered = false
  export let width: 'restricted' | 'full' = 'restricted'
  export let spacing: 'default' | 'none' = 'default'
</script>

<div
  class="paragraph size-{size} width-{width} spacing-{spacing}"
  class:centered
>
  <slot />
</div>

<style lang="postcss">
  .paragraph {
    --_font: 'not set';
    --_pt: 'not set';
    --_pb: 'not set';

    padding-block: var(--_pt) var(--_pb);
    font: var(--_font);

    &.width-restricted {
      max-width: 30em;
    }

    & > :global(p:not(:first-child)) {
      margin-top: 1em;
    }

    &.size-sm {
      --_font: var(--text-sm);
      --_pb: 1.5rem;
    }
    &.size-md {
      --_font: var(--text-md);
      --_pb: 1.5rem;
    }
    &.size-lg {
      --_font: var(--text-lg);
      --_pb: 2.75rem;
    }
    &.size-xl {
      --_font: var(--text-xl);
      --_pb: 4rem;
    }
    &.size-2xl {
      --_font: var(--text-2xl);
      --_pb: 5rem;
    }
    &.centered {
      margin-inline: auto;
      text-align: center;
      &.width-restricted {
        max-width: 26em;
      }
    }
    &.spacing-none {
      padding-block: 0;
    }
  }
</style>
